"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVATION_RULE_VERSION = exports.upgradeActivationRule = void 0;
const v01_1 = require("./versions/v01");
const v02_1 = require("./versions/v02");
const v03_1 = require("./versions/v03");
const v04_1 = require("./versions/v04");
const v05_1 = require("./versions/v05");
const v06_1 = require("./versions/v06");
const v07_1 = require("./versions/v07");
const v08_1 = require("./versions/v08");
const v09_1 = require("./versions/v09");
const v10_1 = require("./versions/v10");
const v11_1 = require("./versions/v11");
const v12_1 = require("./versions/v12");
const v13_1 = require("./versions/v13");
const v14_1 = require("./versions/v14");
const v15_1 = require("./versions/v15");
const v16_1 = require("./versions/v16");
const v17_1 = require("./versions/v17");
const v18_1 = require("./versions/v18");
const v19_1 = require("./versions/v19");
const downgrade = {
    19: v19_1.v19Downgrade,
    18: v18_1.v18Downgrade,
    17: v17_1.v17Downgrade,
    16: v16_1.v16Downgrade,
    15: v15_1.v15Downgrade,
    14: v14_1.v14Downgrade,
    13: v13_1.v13Downgrade,
    12: v12_1.v12Downgrade,
    11: v11_1.v11Downgrade,
    10: v10_1.v10Downgrade,
    9: v09_1.v9Downgrade,
    8: v08_1.v8Downgrade,
    7: v07_1.v7Downgrade,
    6: v06_1.v6Downgrade,
    5: v05_1.v5Downgrade,
    4: v04_1.v4Downgrade,
    3: v03_1.v3Downgrade,
    2: v02_1.v2Downgrade,
    1: v01_1.v1Downgrade,
};
const upgrade = {
    18: v19_1.v19Upgrade,
    17: v18_1.v18Upgrade,
    16: v17_1.v17Upgrade,
    15: v16_1.v16Upgrade,
    14: v15_1.v15Upgrade,
    13: v14_1.v14Upgrade,
    12: v13_1.v13Upgrade,
    11: v12_1.v12Upgrade,
    10: v11_1.v11Upgrade,
    9: v10_1.v10Upgrade,
    8: v09_1.v9Upgrade,
    7: v08_1.v8Upgrade,
    6: v07_1.v7Upgrade,
    5: v06_1.v6Upgrade,
    4: v05_1.v5Upgrade,
    3: v04_1.v4Upgrade,
    2: v03_1.v3Upgrade,
    1: v02_1.v2Upgrade,
    0: v01_1.v1Upgrade,
};
const isActivationRuleV0 = (rule) => {
    return typeof rule === 'object' && !Object.prototype.hasOwnProperty.call(rule, 'schemaVersion');
};
function getRuleSchemaVersion(rule) {
    return !isActivationRuleV0(rule) ? rule.schemaVersion : 0;
}
function isObjKey(key, obj) {
    return key in obj;
}
const isValidUpgradeKey = (version) => isObjKey(version, upgrade);
const isValidDowngradeKey = (version) => isObjKey(version, downgrade);
function isVersionValid(version) {
    return (version === 0 ||
        (typeof version === 'number' && typeof isValidUpgradeKey(version - 1) && typeof isValidDowngradeKey(version)));
}
function validate(inputVersion, outputVersion) {
    if (!isVersionValid(inputVersion)) {
        throw new Error(`Rule has unknown schema version: ${inputVersion}`);
    }
    if (!isVersionValid(outputVersion)) {
        throw new Error(`Requested upgrade to unknown schema version: ${outputVersion}`);
    }
}
function upgradeActivationRule(outputVersion) {
    return (rule) => {
        const inputVersion = getRuleSchemaVersion(rule);
        validate(inputVersion, outputVersion);
        if (inputVersion < outputVersion) {
            // Upgrade the version by 1 and recurse
            // @ts-expect-error getRuleSchemaVersion returns any for inputVersion
            const nextRule = upgrade[inputVersion](rule);
            return upgradeActivationRule(outputVersion)(nextRule);
        }
        if (inputVersion > outputVersion) {
            // Downgrade the version by 1 and recurse
            // @ts-expect-error getRuleSchemaVersion returns any for inputVersion
            const nextRule = downgrade[inputVersion](rule);
            return upgradeActivationRule(outputVersion)(nextRule);
        }
        return rule;
    };
}
exports.upgradeActivationRule = upgradeActivationRule;
exports.ACTIVATION_RULE_VERSION = Object.keys(downgrade)
    .map((stringVersion) => parseInt(stringVersion, 10))
    .sort((a, b) => b - a)[0];
//# sourceMappingURL=upgradeActivationRule.js.map